/* eslint-disable @typescript-eslint/no-explicit-any */
// ES2024 Polyfills for older browsers
// This file imports necessary polyfills from core-js and adds custom ones

// Import core-js polyfills for features we might need
import "core-js/stable"

// Promise.withResolvers polyfill (ES2024)
// This feature is very new and not yet in core-js stable
if (!Promise.withResolvers) {
  Promise.withResolvers = function <T>(): {
    promise: Promise<T>
    resolve: (value: T | PromiseLike<T>) => void
    reject: (reason?: any) => void
  } {
    let resolve!: (value: T | PromiseLike<T>) => void
    let reject!: (reason?: any) => void

    const promise = new Promise<T>((res, rej) => {
      resolve = res
      reject = rej
    })

    return { promise, resolve, reject }
  }
}

// Object.groupBy polyfill (ES2024) - in case we need it later
if (!Object.groupBy) {
  Object.groupBy = function <T, K extends PropertyKey>(
    items: Iterable<T>,
    keySelector: (item: T, index: number) => K,
  ): Partial<Record<K, T[]>> {
    const result: Partial<Record<K, T[]>> = {}
    let index = 0

    for (const item of items) {
      const key = keySelector(item, index++)
      if (!result[key]) {
        result[key] = []
      }
      result[key]!.push(item)
    }

    return result
  }
}

// String.prototype.isWellFormed polyfill (ES2024)
if (!String.prototype.isWellFormed) {
  String.prototype.isWellFormed = function (this: string): boolean {
    try {
      // Try to encode and decode the string to check for well-formed Unicode
      new TextEncoder().encode(this)
      return true
    } catch {
      return false
    }
  }
}

// String.prototype.toWellFormed polyfill (ES2024)
if (!String.prototype.toWellFormed) {
  String.prototype.toWellFormed = function (this: string): string {
    // Replace lone surrogates with replacement character (U+FFFD)
    return this.replace(
      /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g,
      "\uFFFD",
    )
  }
}

export {}
